module.exports = __webpack_public_path__ + "static/white-logo-d87b79c90ad66ac6b2285eac7296f954.svg";